module.exports = __webpack_public_path__ + "img/NicoRoman.401f98b9.jpg";